import React from 'react';
import Card from '@/components/ui/Card';
import { SeasonSummary, SeasonUrlState } from '@/types';

export interface SeasonSelectorProps {
  seasons: SeasonSummary[];
  value?: number;
  from?: string;
  to?: string;
  onChange(next: Pick<SeasonUrlState, 'season' | 'from' | 'to'>): void;
}

const SeasonSelector: React.FC<SeasonSelectorProps> = ({ seasons, value, from, to, onChange }) => (
  <Card>
    <fieldset>
      <legend className="mb-3 text-sm font-semibold text-gray-900 dark:text-gray-100">Season filters</legend>
      <div className="grid gap-4 sm:grid-cols-3">
        <div className="min-w-0">
          <label htmlFor="season-select" className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">Season</label>
          <select id="season-select" value={value ?? ''} onChange={event => onChange({ season: Number(event.target.value), from, to })} className="min-h-11 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100">
            {seasons.map(season => <option key={season.seasonId} value={season.seasonId}>{season.firstDate} to {season.lastDate}</option>)}
          </select>
        </div>
        <div className="min-w-0">
          <label htmlFor="season-from-date" className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">From</label>
          <input id="season-from-date" type="date" value={from ?? ''} max={to} onChange={event => onChange({ season: value, from: event.target.value || undefined, to })} className="min-h-11 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100" />
        </div>
        <div className="min-w-0">
          <label htmlFor="season-to-date" className="mb-1 block text-sm font-medium text-gray-700 dark:text-gray-300">To</label>
          <input id="season-to-date" type="date" value={to ?? ''} min={from} onChange={event => onChange({ season: value, from, to: event.target.value || undefined })} className="min-h-11 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100" />
        </div>
      </div>
      {(from || to) && <button type="button" onClick={() => onChange({ season: value, from: undefined, to: undefined })} className="mt-3 min-h-11 rounded-md px-3 text-sm font-semibold text-club-blue-700 hover:bg-blue-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-blue-500 dark:text-blue-300 dark:hover:bg-blue-950/40">Clear dates</button>}
    </fieldset>
  </Card>
);

export default SeasonSelector;
